import axios from 'axios';
import {
	UPDATE_CHATBOX_HEIGHT,
	TOGGLE_PIPELINE_SHEET,
	SET_SELECTED_CONVERSATIONS,
	SET_TRANSCRIPT_VIEW,
	SET_SHOW_CONVERSATION_DETAILS,
} from './types';
import { writeShowConversationDetails } from '../utils/conversationDetailsPreference';

export const setChatboxHeight = (newHeight) => async (dispatch) => {
	dispatch({ type: UPDATE_CHATBOX_HEIGHT, payload: newHeight });
};

export const setOpenPipelineSheet =
	({ openPipelineSheet, _project, workflowType }) =>
	async (dispatch) => {
		dispatch({
			type: TOGGLE_PIPELINE_SHEET,
			payload: { openPipelineSheet, _project, workflowType },
		});
	};

export const setSelectedConversations =
	(selectedConversations) => async (dispatch) => {
		dispatch({
			type: SET_SELECTED_CONVERSATIONS,
			payload: selectedConversations,
		});
	};

export const setTranscriptView = (transcriptData) => async (dispatch) => {
	// The reducer automatically opens the details panel for a transcript view,
	// so keep the persisted preference in sync with that.
	if (transcriptData) writeShowConversationDetails(true);
	dispatch({
		type: SET_TRANSCRIPT_VIEW,
		payload: transcriptData,
	});
};

export const setShowConversationDetails = (show) => async (dispatch) => {
	writeShowConversationDetails(show);
	dispatch({
		type: SET_SHOW_CONVERSATION_DETAILS,
		payload: show,
	});
};
